export default __webpack_public_path__ + "974bac0139d6effc6575a14e5a43d4eb.jpg";